module.exports = __webpack_public_path__ + "static/img/main_kakao_plus.8dc021d4.svg";